import React from "react";

import { Link } from "gatsby";
import slugify from "slugify";

class CategoryLink extends React.Component {
  render() {
    return (
      <>
        {(this.props.category) ? (
          <Link to={`/essays/category/${slugify(this.props.category).toLowerCase()}`}>
            {this.props.category}
          </Link>
        ) : null}
      </>
    );
  }
}

export default CategoryLink;